<template>
  <table class="table table-striped table-hover bg-white">
    <thead>
      <tr class="cursor-pointer">
        <th v-for="(column, col) in columns" :class="['sticky-header', 'text-'+column.align]" @click="column.sortable && changeSort(column.key)" :key="'header-'+col">
          <div :class="[sort === column.key && 'flex']">
            {{column.name}}
            <i v-if="sort === column.key" :class="['icon', 'ml-2', order === 'asc' ? 'icon-arrow-up' : 'icon-arrow-down']"/>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, row) in orderedItems" :key="'row-'+row" @click="$emit('rowSelected', [row, item])" class="cursor-pointer">
        <td v-for="(column, col) in columns" :class="['text-'+column.align, column.type === 'boolean' && ['flex', 'justify-center']]" :key="'item-'+row+'-'+col">
          <img v-if="column.type === 'image'" :src="item[column.key]"/>
          <div v-else-if="column.type === 'boolean'" :class="[item[column.key] ? 'bg-green' : 'bg-red']" style="width: 10px; height: 10px; border-radius:5px;"></div>
          <div v-else v-html="column.transform ? column.transform(item[column.key]) : item[column.key]"></div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'SortableTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    startSort: {
      type: String
    },
    startSortOrder: {
      type: String
    }
  },
  data() {
    return {
      sort: '',
      order: 'asc'
    }
  },
  computed: {
    orderedItems() {
      return this.items.sort((a, b) => {
        var response = 0
        if (a[this.sort] < b[this.sort]) {
          response = -1
        } else if (a[this.sort] > b[this.sort]) {
          response = 1
        }
        return this.order === 'asc' ? response : response * -1
      });
    }
  },
  methods: {
    changeSort(item) {
      if (item === this.sort) {
        this.order === 'asc' ? this.order = 'des' : this.order = 'asc'
      } else {
        this.order = 'asc'
        this.sort = item
      }
    }
  },
  created() {
    if (this.startSort) {
      this.sort = this.startSort
      if (this.startSortOrder) {
        this.order = this.startSortOrder
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  thead tr:nth-child(1) th{
    background-color: white;
    position: sticky;
    top: 0;
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SortableTable.vue